import { IOmniaShell, SharedFieldsService } from "../omnia"
import { PlanApi } from "./api"
import { PlanAction } from "./reducer"
import { MapFactory } from "./types"

const planContext = {
    api: undefined as PlanApi,
    dispatch: undefined as React.Dispatch<PlanAction>,
    shell: undefined as IOmniaShell,
    fieldSvc: undefined as SharedFieldsService,
    mapFactory: undefined as MapFactory
}

export type PlanContext = typeof planContext

export const PlanContext = React.createContext(planContext)
